import React from 'react'

import useStyle from 'shared/hooks/useStyle'
import styles from './SummaryChoicesList.style'

const EmptyIcon = () => {
    const classes = useStyle(styles)

    return (
        <span css={classes.icon} />
    )
}

export default EmptyIcon
